import AsyncSelect from 'Common/AsyncSelect/AsyncSelect'
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import CustomInput from 'Common/CustomInput/CustomInput'
import CustomLabel from 'Common/CustomLabel/CustomLabel'
import CustomSelect from 'Common/CustomSelect/CustomSelect'
import ExportExcel from 'Components/ExportExcel/ExportExcel'
import FilterSearch from 'Components/FilterSearch/FilterSearch'
import Show from 'Components/Show/Show'
import SuperAccordion from 'Components/SuperAccordion/SuperAccordion'
import React, { useState } from 'react'
import { Tooltip } from 'react-tooltip'
import ParamListGen from 'Services/ParamListGen'
import PlusIcon from 'SVGS/PlusIcon'
import { PATIENT_SIDE_PATIENT_PAYMENT_TABS } from 'Common/Constants'
import PatientSuperSearch from 'NewComponents/UtilityComponents/PatientSuperSearch/PatientSuperSearch'

const PatientPaymentForm = ({ searchModel, fromPatientSide = false, activeTab, handlePaymentId, superSearchPatientValue, setSuperSearchPatientValue, handleSubmit, handleClear, onHandleChange, setSearchModel, paramModel, filterCount,
    paymentIdLoader, handleFilterSuperSearchPayment, superPaymentIdValue, superRequestIdValue, handleFilterSuperSearchRequest, openNewPatientPaymentPopup

}) => {
    const [activeElement, setActiveElement] = useState(null);
    const handleToggle = (element) => {
        if (activeElement === element) {
            setActiveElement(null);
        } else {
            setActiveElement(element);
        }
    };
    const handleSelectedData = (selectedObj) => {
        if (selectedObj) {
            setSearchModel((prev) => ({
                ...prev,
                patientId: selectedObj.id,
            }))
            setSuperSearchPatientValue(selectedObj.name)
        } else {
            setSearchModel((prev) => ({
                ...prev, patientId: "",
            }))
            setSuperSearchPatientValue("")
        }
    }
    return (
        <div className="mb-4">

            <div className="flex justify-between">
                <Tooltip id={"PatientPaymentFormFilterSearch"} style={{ maxWidth: 300, zIndex: 12 }} />
                <div data-tooltip-id={"PatientPaymentFormFilterSearch"} data-tooltip-content="Only number values are allowed" className="flex items-center w-[355px]  ">
                    <FilterSearch
                        filterCount={filterCount}
                        activeElement={activeElement}
                        handleToggle={handleToggle}
                        loading={paymentIdLoader}
                        handleFilterSuperSearch={activeTab === PATIENT_SIDE_PATIENT_PAYMENT_TABS.REQUEST_PAYMENTS ? handleFilterSuperSearchRequest : handleFilterSuperSearchPayment}
                        superSearchValue={activeTab === PATIENT_SIDE_PATIENT_PAYMENT_TABS.REQUEST_PAYMENTS ? superRequestIdValue : superPaymentIdValue}
                        placeholder={`${activeTab === PATIENT_SIDE_PATIENT_PAYMENT_TABS.REQUEST_PAYMENTS ? "Search Request #..." : "Search Payment #..."} `}
                        isNumeric
                    />
                </div>
                <div className={`flex gap-4 ${fromPatientSide ? '-mt-8' : ''}`}>
                    <Show when={activeTab !== PATIENT_SIDE_PATIENT_PAYMENT_TABS.REQUEST_PAYMENTS}>
                        <div className="">
                            <CustomSelect name="poststatus" value={searchModel.poststatus} onChange={onHandleChange}  >
                                <option value='All'>All</option>
                                <option value='NeedPosting'>Unposted</option>
                                <option value='Posted'>Posted</option>
                            </CustomSelect>
                        </div>
                    </Show>
                    <ExportExcel model={{ ...paramModel, isExportCall: true, param_list: ParamListGen(searchModel) }}
                        API={`${process.env.REACT_APP_TC_PMS}/api/patientpayment/v2/FindPatientPayments`}
                        file Name="Patient Payment Report"
                    />
                    {/* <CustomButtonNew prefixIcon={<PlusIcon />} onClick={() => handlePaymentId(0)} label="Add Payment" /> */}
                    <CustomButtonNew className='h-fit' prefixIcon={<PlusIcon />} variant={`${fromPatientSide ? 'outline' : 'filled'}`} color={`${fromPatientSide ? 'secondary' : 'primary'}`} onClick={openNewPatientPaymentPopup} label="Add Payment" />
                </div>
            </div>
            <SuperAccordion id='patientPaymentSearchGrid' show={activeElement === 0}>
                <div className="grid grid-cols-12 gap-4 pt-8 pb-4">
                    {!fromPatientSide &&
                        <div className="col-span-12 md:col-span-2">
                            <div className="flex gap-2 pb-2">
                                <CustomLabel label="Patient" toolTip="Search by patient account number, patient name, or date of birth (format mm/dd/yyyy)" />

                            </div>
                            <PatientSuperSearch
                                searchValue={superSearchPatientValue}
                                onChange={(value) => { setSuperSearchPatientValue(value) }}
                                handleSelectedData={handleSelectedData}
                                width='100%'
                            />
                        </div>
                    }
                    {/* <div className="col-span-12 md:col-span-2">
                        <CustomInput name="paymentId" value={searchModel.paymentId} onChange={onHandleChange} label="Payment #" type="number" placeholder="Payment ID" required={false} />
                    </div> */}
                    <div className="col-span-12 md:col-span-2">
                        <CustomSelect name="paymentSource" disabled={activeTab === PATIENT_SIDE_PATIENT_PAYMENT_TABS.REQUEST_PAYMENTS} value={searchModel.paymentSource} onChange={onHandleChange} label="Payment Source" >
                            {activeTab === PATIENT_SIDE_PATIENT_PAYMENT_TABS.REQUEST_PAYMENTS ?
                                <option >Payment Request </option> :
                                <>
                                    <option value=''>All</option>
                                    <option >Terminal</option>
                                    <option >External </option>
                                    <option >Online</option>
                                </>
                            }
                        </CustomSelect>
                    </div>
                    <div className="col-span-12 md:col-span-2">
                        <AsyncSelect
                            value={searchModel.locationId} name="locationId" onChange={onHandleChange} label="Location"
                            apiLink={`${process.env.REACT_APP_TC_PMS}/api/DropDown/FindLocations`}
                        />
                    </div>

                    <div className="col-span-12 md:col-span-2">
                        <CustomInput name="checknumber" value={searchModel.checknumber} onChange={onHandleChange} label="Check #" type="text" placeholder="Check#" required={false} />
                    </div>
                    <div className="col-span-12 md:col-span-2">
                        <CustomInput name="receiptNumber" value={searchModel.receiptNumber} onChange={onHandleChange} label="Receipt #" type="text" placeholder="Receipt#" required={false} />
                    </div>
                    <div className="col-span-12 md:col-span-2">
                        <CustomInput name="CCTransactionId" value={searchModel.CCTransactionId} onChange={onHandleChange} label="Stripe Transaction #" type="text" placeholder="Stripe Transaction ID" required={false} />
                    </div>
                    <div className="col-span-12 md:col-span-2">
                        <CustomInput name="receiveddatefrom" type="date" value={searchModel.receiveddatefrom} onChange={onHandleChange} label="Received Date From" />
                    </div>
                    <div className="col-span-12 md:col-span-2">
                        <CustomInput name="receiveddateto" type="date" value={searchModel.receiveddateto} onChange={onHandleChange} label="Received Date To" />
                    </div>
                    <div className="flex justify-end col-span-12 gap-2">
                        <CustomButtonNew label="Clear" onClick={handleClear} variant="outline" />
                        <CustomButtonNew onClick={() => handleSubmit()} label="Search" />
                    </div>
                </div>
            </SuperAccordion>
        </div>
    )
}

export default PatientPaymentForm
